var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0.5H1.875C0.84375 0.5 0.00937499 1.34375 0.00937499 2.375L0 13.625C0 14.6562 0.84375 15.5 1.875 15.5H16.875C17.9062 15.5 18.75 14.6562 18.75 13.625V2.375C18.75 1.34375 17.9062 0.5 16.875 0.5ZM16.5 4.48438L9.87187 8.62813C9.57187 8.81563 9.17813 8.81563 8.87813 8.62813L2.25 4.48438C2.15599 4.4316 2.07367 4.36031 2.00802 4.2748C1.94237 4.18929 1.89475 4.09135 1.86804 3.98691C1.84133 3.88247 1.8361 3.77369 1.85265 3.66716C1.8692 3.56064 1.90719 3.45858 1.96433 3.36716C2.02146 3.27574 2.09655 3.19686 2.18506 3.13531C2.27356 3.07375 2.37363 3.03079 2.47921 3.00903C2.5848 2.98727 2.6937 2.98716 2.79933 3.0087C2.90496 3.03025 3.00512 3.073 3.09375 3.13437L9.375 7.0625L15.6563 3.13437C15.7449 3.073 15.845 3.03025 15.9507 3.0087C16.0563 2.98716 16.1652 2.98727 16.2708 3.00903C16.3764 3.03079 16.4764 3.07375 16.5649 3.13531C16.6534 3.19686 16.7285 3.27574 16.7857 3.36716C16.8428 3.45858 16.8808 3.56064 16.8974 3.66716C16.9139 3.77369 16.9087 3.88247 16.882 3.98691C16.8553 4.09135 16.8076 4.18929 16.742 4.2748C16.6763 4.36031 16.594 4.4316 16.5 4.48438Z",
    fill: "url(#paint0_linear_535_98)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_535_98",
    x1: 0.298696,
    y1: 6.8905,
    x2: 18.7618,
    y2: 6.94957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1063AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#1B7E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B5D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/vector8.ee56e29bc44afaa660b10f1b846cfc01.svg";
export { ForwardRef as ReactComponent };